export default "__VITE_PUBLIC_ASSET__4c19d9c7__"